<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import ReportApi from '../services/ReportApi'
//import { useStore } from '../services/store'

const props = defineProps({ 
    exportOn: Boolean,
    companyId: Number,
    memberId: Number,
    projectId: Number,
    startDate: String,
    endDate: String
})
const emit = defineEmits(['update:exportOn'])
const type = ref(null);
const loading = ref(false);
const message = ref('');
const snackbar = ref(false);
const timeout = ref(5000);
const backgroundProcessId = ref(null);

const getExport = () => {

    loading.value = true;
    ReportApi.export({
        startDate: props.startDate,
        endDate: props.endDate,
        companyId: props.companyId,
        projectId: props.projectId,
        memberId: props.memberId,
        exportType: type.value
    }).then((response) => {

        if(response.data.status != 'Faulted' && response.data.status != 'Canceled') {
            backgroundProcessId.value = response.data.backgroundProcessID;
            setTimeout(() => {
                getPingServer()
            }, 500);
        }
        else {
            message.value = response.data.message;
            snackbar.value = true;
            backgroundProcessId.value = null;
            loading.value = false;
        }
    }).catch((ex) => {
        message.value = ex.message;
        snackbar.value = true;
        backgroundProcessId.value = null;
        loading.value = false;
    })
}

const getPingServer = () => {
    if(!backgroundProcessId.value) {
        return;
    }

    ReportApi.exportStatus(backgroundProcessId.value)
        .then((response) => {
            if(response.data.status == 'Faulted' || response.data.status == 'Canceled') {
                backgroundProcessId.value = null;
                message.value = response.data.message;
                snackbar.value = true;
                loading.value = false;
            }
            else if(response.data.status == 'RanToCompletion') {
                downloadFile(response.data.backgroundProcessID, response.data.extension);
                backgroundProcessId.value = null;
                loading.value = false;
            }
            else {
                setTimeout(() => {
                    getPingServer()
                }, 500);
            }
        })
        .catch((ex) => {
            message.value = ex.message;
            backgroundProcessId.value = null;
            snackbar.value = true;
            loading.value = false;
        }) 
}

const downloadFile = (id, ext) => {
    ReportApi.exportDownload(id, ext)
        .then((response) => { 
            const href = URL.createObjectURL(response.data);
            const filename = response.headers.get("Content-Disposition") ? response.headers.get("Content-Disposition").replace('attachment; filename=', '') : 'export.' + ext;
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);
            message.value = "Export successful!";
            snackbar.value = true;
            setTimeout(() => {
                    emit('update:exportOn', false)
                }, 1000);
            
        });
}

</script>

<template>
    <v-dialog :model-value="props.exportOn" max-width="500">
        <v-card title="Export Report" >
            <v-progress-linear indeterminate :active="loading"></v-progress-linear>
            <v-card-text>
                <v-select v-model="type" item-value="type" item-title="value" label="Export Template" :items="[ { type: 'xlsxdefault', value: 'Excel Default' }, { type: 'csvdefault', value: 'Csv Default' } ]" ></v-select>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text="Dismist" @click="emit('update:exportOn', false)"></v-btn>
                <v-btn text="Export" color="success" :disabled="!type" @click="getExport" ></v-btn>
            </v-card-actions>
        </v-card>
        
    </v-dialog>

    <v-snackbar v-model="snackbar" >{{ message }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
</template>